import React from "react";
import { Modal } from "@arco-design/web-react";

// MUI -> Arco. Dialog(+Title/Content/Actions) -> Modal with visible/onOk/
// onCancel/title; the Cancel/Delete DialogActions buttons become the Modal's
// okText/cancelText. Logic + props (open/onDelete/onClose/senderEmail) untouched.
export default function DeleteSenderEmailDialog({ open, onDelete, onClose, senderEmail }) {
  // const [open, setOpen] = React.useState(false);

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  const handleClose = () => {
    // setOpen(false);
    onClose && onClose();
  };

  const handleDelete = () => {
    onDelete && onDelete();
    handleClose();
  };

  return (
    <Modal
      visible={open}
      onCancel={handleClose}
      onOk={handleDelete}
      title="Delete Sender Email"
      okText="Delete"
      cancelText="Cancel"
    >
      Are you sure you want to delete sender email?
    </Modal>
  );
}
